<template>
    <div>
        <div class="wrapper text text--align-center">

            <div class="remove-padding">
                <img class="start-image" :src="require(`@/assets/${currentData.image}`)">
            </div>

            <p v-html="currentData.copy">
            </p>
            <p class="text text--red margin margin--bottom-20 remove-padding" v-html="currentData.copyRed">
            </p>
            <router-link :to="'/activityType/' + this.$route.params.id + '/game'" class="button">{{currentData.buttonCopy}}</router-link>

        </div>
    </div>
</template>
<script>

    import data from '../assets/data/data';

    export default {
        name: 'Start',
        data: function(){
            return {
                data: data
            }
        },
        computed: {

            currentData: function(){
                return this.data.activities[this.$route.params.id].start;
            }
        }
    }


</script>
